import React from 'react';

export default function FooterSection() {
  return (
    <footer className="w-full bg-white dark:bg-clinical-slate-900 border-t border-gray-200 dark:border-gray-800 shadow-[0_-1px_12px_rgba(0,0,0,0.03)] mt-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12">
          {/* Practice Summary */}
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center gap-3">
              <span className="text-xl font-bold text-gray-900 dark:text-white tracking-tight">
                NFBG SCORPIO
              </span>
              <span className="px-3 py-0.5 rounded-full bg-ice-cyan dark:bg-clinical-slate-800 text-primary dark:text-primary-fixed text-[10px] uppercase font-bold tracking-wider">
                Executive Healthcare
              </span>
            </div>

            <p className="text-sm text-gray-600 dark:text-slate-300 max-w-lg leading-relaxed">
              Executive consulting, clinical leadership guidance, and confidential healthcare dispute resolution
              for hospital systems, physician groups, and C-suite leadership.
            </p>

            <div className="flex flex-wrap items-center gap-2 pt-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-surface-container dark:bg-clinical-slate-800 text-gray-700 dark:text-slate-300 text-xs font-medium border border-gray-200 dark:border-gray-700">
                <span className="material-symbols-outlined text-accent-teal text-[16px]">verified</span>
                <span>Prosci® Certified Change Practitioner</span>
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-surface-container dark:bg-clinical-slate-800 text-gray-700 dark:text-slate-300 text-xs font-medium border border-gray-200 dark:border-gray-700">
                <span className="material-symbols-outlined text-primary text-[16px]">gavel</span>
                <span>Confidential Healthcare ADR Protocol</span>
              </span>
            </div>
          </div>

          {/* Practice Domains */}
          <div className="space-y-3">
            <span className="text-xs uppercase tracking-wider text-gray-900 dark:text-white font-bold block">
              Practice Domains
            </span>
            <ul className="space-y-2 text-xs sm:text-sm text-gray-600 dark:text-slate-300">
              <li className="hover:text-primary dark:hover:text-primary-fixed transition-colors cursor-pointer">
                Executive Physician Coaching
              </li>
              <li className="hover:text-primary dark:hover:text-primary-fixed transition-colors cursor-pointer">
                Hospital Board Dispute Mediation
              </li>
              <li className="hover:text-primary dark:hover:text-primary-fixed transition-colors cursor-pointer">
                Clinical Mergers &amp; Cultural Alignment
              </li>
              <li className="hover:text-primary dark:hover:text-primary-fixed transition-colors cursor-pointer">
                High-Stakes Medical Staff Inquiries
              </li>
            </ul>
          </div>

          {/* Executive Office */}
          <div className="space-y-3">
            <span className="text-xs uppercase tracking-wider text-gray-900 dark:text-white font-bold block">
              Executive Office
            </span>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-slate-300">
              Confidential Concierge Line &amp; Leadership Inquiries
            </p>
            <p className="text-sm font-semibold text-primary dark:text-primary-fixed">
              advisory@nfbgscorpio.com
            </p>
            <p className="text-xs text-gray-400 dark:text-gray-500">
              Direct line priority access granted post engagement screening.
            </p>
          </div>
        </div>

        {/* Sub-footer */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-gray-150 dark:border-gray-800">
          <p className="text-xs text-gray-500 dark:text-gray-400 text-center md:text-left">
            &copy; 2026 NFBG Scorpio Advisory LLC. All professional healthcare dispute resolution procedures operate under privileged statutory protections.
          </p>
          <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
            <span>Privileged &amp; Confidential</span>
            <span>&bull;</span>
            <span>Prosci® Change Governance</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
